<template>
  <div class="sui-radio-group">
    <template v-for="(option, _index) in options" :key="_index">
      <RadioButton
        v-model="redio_group_model"
        :name="name" 
        :value="option.value" 
        :label="option.label" 
        :disabled="disabled" 
        :has-errors="hasErrors"
      ></RadioButton>
    </template>
  </div>
</template>
  
<script setup lang="ts">
  import { toRefs, computed } from 'vue'

  // Components
  import RadioButton from '../radio/RadioButton.vue'

  const props = defineProps({
    modelValue: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    name: {
      type: String,
      default: ''
    },
    options: {
      type: Array<{ [key:string]: any }>,
      default: () => []
    },
    hasErrors: {
      type: Boolean,
      default: false
    }
  })

  const { disabled, modelValue, name, hasErrors, options } = toRefs(props)

  const emit = defineEmits(['update:modelValue', 'change'])

  const redio_group_model = computed({
    get() {
      return modelValue.value
    },
    set(val: any) {
      emit('update:modelValue', val)
    }
  })
</script>
  
<style scoped lang="scss">
.sui-radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;

}
</style>
